import { MouseEvent } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { AppDispatch } from '../../../store/models/app-dispatch.model';
import { PaginationDefaultsModel } from '../../models/pagination-defaults.model';
import { PaginationDefaults } from '../pagination-defaults.util';

export const onTablePageChange = (
  dispatch: AppDispatch,
  rowsPerPage: number,
  addPaginationAction: ActionCreatorWithPayload<
    PaginationDefaultsModel,
    string
  >,
  callbackFn?: () => void
): ((event: MouseEvent<HTMLButtonElement> | null, newPage: number) => void) => {
  return (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    callbackFn?.();
    dispatch(
      addPaginationAction({
        size: rowsPerPage,
        offset: rowsPerPage * newPage,
        pageNumber: newPage,
        totalCount: PaginationDefaults.totalCount,
      })
    );
  };
};
